import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LandingComponent } from './landing/landing.component';
import { HeaderComponent } from './header/header.component';
import { DeviceComponent } from './device/device.component';
import { FooterComponent } from './footer/footer.component';
import { QuickLookComponent } from './landing/quick-look/quick-look.component';
import { FeaturesComponent } from './landing/features/features.component';
import { DetailsComponent } from './landing/details/details.component';
import { ConceptComponent } from './landing/concept/concept.component';
import { OpportunitiesComponent } from './landing/opportunities/opportunities.component';

@NgModule({
  declarations: [
    AppComponent,
    LandingComponent,
    HeaderComponent,
    DeviceComponent,
    FooterComponent,
    QuickLookComponent,
    FeaturesComponent,
    DetailsComponent,
    ConceptComponent,
    OpportunitiesComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
